<template>
  <div class="k-filter-selected" v-if="itemList.length > 0">
    <div class="title k-body-md">
      {{ title }}
    </div>
    <div class="item k-body-md" :class="{'can-delete': item?.delete}" v-for="(item, index) in itemList" :key="index">
      <span class="text">{{ item?.display }}</span>
      <span v-if="item?.delete" @click="onDeleteItem(item)" >
          <KkIcon name="ic_cross_line" size="xs" class="kk-u-text-primary-medium k-icon-cursor" />
        </span>
    </div>
    <div class="clean-btn k-subtitle-md" v-if="showClean && itemList.length > 0 && hasDeleteItem">
      <span @click="onClean">{{ cleanText }}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { KkIcon } from '@kkday/web-design-system'

export default {
  components: {
    KkIcon
  },
  data() {
    return {
      itemList: [] //[{display:"显示出的文本",delete: true/false,.....}]
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    showClean: {
      type: Boolean,
      default: true
    },
    cleanText: {
      type: String,
      default: ''
    },
    // 按是否可移除做排序，启用后：不可移除在前，可移除在后
    sortByDelete: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    items: {
      handler() {
        this.initItem()
      },
      immediate: true
    }
  },
  computed: {
    hasDeleteItem() {
      return _.some(this.itemList, ['delete', true])
    }
  },
  created() {
    this.initItem()
  },
  methods: {
    initItem() {
      const itemList = _.cloneDeep(this.items)
      this.itemList = _.sortBy(itemList, function(o) {
        return o?.delete
      })
    },
    // 这里不真正的移除，只做通知，真正的移除交由业务判断，同步移除后的数据即可
    onDeleteItem(item) {
      if (item?.delete) {
        this.$emit('delete', item)
      }
    },
    onClean() {
      this.$emit('clean')
    }
  }
}
</script>

<style lang="less" scoped>
.k-filter-selected{
  display: flex;
  flex-flow: wrap;
  width: 100%;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  background-color: #FFF;
  .title {
    margin-right: 14px;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 6px 14px;
    margin: 4px 8px 4px 0px;
    border-radius: 20px;
    color: #26BEC9;
    border: 1px solid #26BEC9;
    background-color: #F0FAFB;
    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break: break-all;
      text-align: left;
    }
  }
  .item:hover {
    color: #26BEC9;
    border: 1px solid #26BEC9;
    background-color: #CEF0F3;
  }
  .can-delete {
    padding: 6px 10px 6px 14px;
  }
  .clean-btn {
    color: #26BEC9;
    cursor: pointer;
  }
}
</style>
